import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ServiceImagesType } from '../../data-access/models/selected-section.type';
import { DpIconComponent } from '@client-monorepo/common/icon';
import { ApiImageModule } from '@digipay/ng-ui-api-image';
import { StatusLightDirective } from '../status-light/status-light.directive';
import { StatusLightSizesEnum } from '../../data-access/constants/status-light-sizes.enum';
import { StatusLightBordersEnum } from '../../data-access/constants/status-light-boders.enum';
import { StatusLightColorsEnum } from '../../data-access/constants/status-light-colors.enum';
import { PipesModule } from '@digipay/ng-lib-pipes';
import { TrackableIdDirective } from '@client-monorepo/common/utilities';
import { FramedIconGradientModel } from '../../data-access/models/framed-icon-gradient.model';

@Component({
  selector: 'common-ui-components-framed-icon',
  standalone: true,
  imports: [CommonModule, DpIconComponent, ApiImageModule, StatusLightDirective, NgOptimizedImage, PipesModule, TrackableIdDirective],
  templateUrl: './framed-icon.component.html',
  styleUrl: './framed-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FramedIconComponent {
  // Inputs
  type = input<ServiceImagesType>(ServiceImagesType.ICON);
  size = input<'XS' | 'SMALL' | 'MEDIUM' | 'LARGE'>('MEDIUM');
  icon = input<string>('');
  iconType = input<'linear' | 'bold' | 'due'>('linear');
  enableGradient = input<boolean>(false);
  iconStyle = input<string>('');
  showText = input<boolean>(false);
  text = input<string>('');
  maxTextLength = input<number | undefined>(undefined);
  bg = input<'surface-back' | 'surface-elevated'>('surface-back');
  showBadge = input<boolean>(false);
  showStatusLight = input<boolean>(false);
  statusLightSize = input<StatusLightSizesEnum>();
  statusLightColor = input<StatusLightColorsEnum>();
  statusLightBorderColor = input<StatusLightBordersEnum>();
  enableMixedBlendMode = input<boolean>(false);
  trackerIdPrefix = input<string>('');
  gradientConfig = input<FramedIconGradientModel>({} as FramedIconGradientModel);
  innerBoxStyle = computed(() => {
    // For Gradient
    const config = this.gradientConfig();
    return {
      background: this.enableGradient()
        ? `linear-gradient(${config.degree}deg, ${config.start.color} ${config.start.point}%, ${config.end.color} ${config.end.point}%)`
        : '',
    };
  });

  // Variables
  readonly ServiceImagesType = ServiceImagesType;
  sizeToStylesMapper = {
    XS: { iconWrapperClasses: 'p-medium radius-minus size-40', wrapperClasses: 'gap-low', iconSize: '24', textClasses: 'l-2' },
    SMALL: { iconWrapperClasses: 'p-medium radius-medium size-48', wrapperClasses: 'gap-low', iconSize: '32', textClasses: 'l-2' },
    MEDIUM: { iconWrapperClasses: 'p-plus radius-medium size-52', wrapperClasses: 'gap-low', iconSize: '32', textClasses: 'l-2' },
    LARGE: { iconWrapperClasses: 'p-huge radius-big size-72', wrapperClasses: 'gap-small', iconSize: '40', textClasses: 'c-3' },
  };
  generatedStyles = computed(() => this.sizeToStylesMapper[this.size()]);
}
